// test871
(871 && 0);
